import { z } from 'zod';

export const add = async (dataClassification: DataClassification): Promise<boolean> => {
    const res = await fetch(`/DataClassification`, {
        method: 'POST',
        body: JSON.stringify(dataClassification),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};

export const all = async (params: object): Promise<DataClassification[]> => {
    let queryString = '';
    if (params) {
        const paramsAsString = JSON.stringify(params)
            .replace(/:/g, '=')
            .replace(/,/g, '&')
            .replace(/[{}"]/g, '');

        const searchParams = new URLSearchParams(paramsAsString);
        queryString = `?${searchParams.toString()}`;
    }

    const response = await fetch(`/DataClassification${queryString}`);

    return await response.json();
};

export const update = async (dataClassification: DataClassification): Promise<boolean> => {
    const res = await fetch(`/DataClassification`, {
        method: 'PATCH',
        body: JSON.stringify(dataClassification),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
export const DataClassificationSchema = z.object({
    id: z.number().nullable(),
    name: z.string().nonempty({ message: 'A data classification name is required.' }),
    slug: z.string().nullable(),
    deletedOn: z.date().nullable(),
});

export type DataClassification = z.infer<typeof DataClassificationSchema>;
